import * as React from 'react'
import { Link } from 'react-router-dom'
import { SERVICE_LIST_TYPE } from '../../../state/constants/index'
import HorizontalSelector from '../../HorizontalSelector'
import HorizontalSelectorItem from '../../HorizontalSelectorItem'

export interface IServiceListTypeSelectorProps {
  type: SERVICE_LIST_TYPE.ACTIVE | SERVICE_LIST_TYPE.ARCHIVED
  url: string
}

const ServiceListTypeSelector = ({ type, url }: IServiceListTypeSelectorProps) => (
  <div className='ml2'>
    <HorizontalSelector>
      <HorizontalSelectorItem isSelected={type === SERVICE_LIST_TYPE.ACTIVE}>
        <Link to={`${url}/active`}>SERVICES</Link>
      </HorizontalSelectorItem>
      <HorizontalSelectorItem isSelected={type === SERVICE_LIST_TYPE.ARCHIVED}>
        <Link to={`${url}/archived`}>ARCHIVED SERVICES</Link>
      </HorizontalSelectorItem>
    </HorizontalSelector>
  </div>
)

export default ServiceListTypeSelector



// WEBPACK FOOTER //
// ./src/components/services/list/ServiceListTypeSelector.tsx